import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  paper: {
    overflowY: "hidden",
  },
}));
